// extracted by mini-css-extract-plugin
module.exports = {"container":"snackbar_container__4F3_d"};